export var centerCellStyle = {display:'flex',alignItems:'center'};
export var dateCellStyle = {display:'flex',alignItems:'flex-start',flexDirection:'column',justifyContent:'center'};